<template>
  <div>
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      :title="'Firma: ' + ACTNAME"
    >
      <div>
        <b-row>
          <b-col>
            <vs-card>
              <b-form @submit.prevent>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Aktif Talep"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input
                      :disabled="true"
                      id="h-first-name"
                      v-model="talep"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Fiyat"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-row>
                      <b-col cols="3" style="padding-right: 0px">
                        <v-select
                          :color="select2"
                          v-model="fiyatSecilen"
                          :options="fiyatlar"
                          @input="changedLabel"
                          style="
                            border-top-right-radius: 0;
                            border-bottom-right-radius: 0;
                          "
                          autocomplete
                          ref="selectElement"
                        >
                          <template slot="option" slot-scope="option">
                            {{ option.ACTID }} / {{ option.FTUR }}
                          </template>
                        </v-select>
                      </b-col>
                      <b-col cols="9" style="padding-left: 0px">
                        <b-form-input
                          style="
                            border-top-left-radius: 0;
                            border-bottom-left-radius: 0;
                          "
                          id="h-first-name"
                          v-model="inputValFiyat"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Miktar"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-input id="h-first-name" v-model="miktar" />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="İstenen Tarih"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <b-form-datepicker
                      v-model="istenenTarih"
                      :placeholder="getNow()"
                      size="sm"
                      local="en"
                      class="mb-2"
                      today-variant="danger"
                      :start-weekday="weekday"
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                    />
                  </b-col>
                </b-row>
                <b-row style="margin-bottom: 10px">
                  <b-col cols="4" align-self="center">
                    <b-form-group
                      label="Açıklama"
                      label-for="h-first-name"
                      style="font-size: 15px"
                    >
                    </b-form-group>
                  </b-col>
                  <b-col cols="8">
                    <vs-textarea label="Açıklama" v-model="textareaNot" />
                  </b-col>
                </b-row>
              </b-form>
            </vs-card>
          </b-col>
        </b-row>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="md"
            class="float-right"
            @click="cancel()"
          >
            İptal
          </b-button>
          <b-button
            style="margin-right: 25px"
            size="md"
            variant="success"
            class="float-right"
            @click="sepeteEkle()"
          >
            Ekle
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import { BFormDatepicker } from "bootstrap-vue";
import moment from "moment";
export default {
  data() {
    return {
      weekday:1,
      select2: "primary",
      inputValFiyat: "",
      ACTID: "",
      ACTNAME: "",
      STOCKID: "",
      fiyatlar: [],
      fiyatSecilen: "",
      textareaNot: "",
      talep: "",
      miktar: "",
      istenenTarih: "",
    };
  },
  components: {
    BFormDatepicker,
    "v-select": vSelect,
    //PazaryeriTopluGuncelleme,
  },
  methods: {
    changedLabel(event) {
      console.log(event);
      this.inputValFiyat = event.ACTID;
    },

    sepet() {
      this.talep = "1";
      this.ACTID = Store.state.account.sepetACTID;
      this.ACTNAME = Store.state.account.sepetACTNAME;
      this.STOCKID = Store.state.account.sepetSTOKID;
      this.$refs["modal-primary "].show();
      this.detayList();
    },
    detayList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.STOCKID,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Ls_Stock_TalepStokSec(args, function (err, result) {
          if (result.INT_Ls_Stock_TalepStokSecResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          vm.veriler = JSON.parse(result.INT_Ls_Stock_TalepStokSecResult);
          vm.fiyatlar = vm.veriler;
          console.log(vm.fiyatlar);
          //  vm.alimListesi = vm.veriler;
          // vm.rowData = vm.veriler;
        });
      });
    },
    cancel() {
      this.$refs["modal-primary "].hide();
      this.miktar = "";
      this.inputValFiyat = "";
      this.textareaNot = "";
      this.ACTID = "";
      this.istenenTarih = "";
    },
    sepeteEkle() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var formattoday = new Date();
      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.STOCKID,
        TRANSDATE: moment(String(formattoday)).format("YYYY-MM-DD"),
        TALEPTARIHI: vm.istenenTarih,
        EMPLOYEEID: Store.state.UserId,
        ADET: vm.miktar,
        FIYAT: vm.inputValFiyat,
        TUTAR: vm.miktar * vm.inputValFiyat,
        ACTID: vm.ACTID,
        ACIKLAMA: vm.textareaNot,
      };

      soap.createClient(url, function (err, client) {
        client.INT_Sal_SatinalmaTalepEkle(args, function (err, result) {
          if (result.INT_Sal_SatinalmaTalepEkleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_Sal_SatinalmaTalepEkleResult);
            console.log(vm.veriler);
            vs.notify({
              title: "Sepet",
              text: "Sepete Eklendi",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "success",
              position: "top-center",
            });
          } catch (error) {
            console.log(result);
            vs.notify({
              title: "Sepet",
              text: "Sepete Eklenirken Hata Oluştu",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
          }
        });
      });
      vm.miktar = "";
      vm.inputValFiyat = "";
      vm.textareaNot = "";
      vm.ACTID = "";
      vm.istenenTarih = "";
      vm.$refs["modal-primary "].hide();
      this.$root.$emit("talepHavuzuList");
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() +
        "." +
        (today.getMonth() + 1) +
        "." +
        today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.v-select .vs__dropdown-toggle .vs__actions .vs__clear {
  display: none;
}
.v-select__selections {
  max-height: 30px !important;
}
</style>